/* esm.sh - rxjs@7.8.1/dist/esm/internal/util/isScheduler */
import{isFunction as e}from"./isFunction.mjs";function n(r){return r&&e(r.schedule)}export{n as isScheduler};
//# sourceMappingURL=isScheduler.mjs.map